import {GET_PP} from "../actions/pp.actions";

const initialState = {};

export default function contactsReducer( state = initialState, action) {

    switch (action.type) {
        case GET_PP:
            return action.payload;

        default:
            return state;
    }
}